<div class="total-padding" [style.height]="scrollHeight + 'px'"></div>
<div class="scrollable-content" #content [style.transform]="'translateY(' + topPadding + 'px)'">
  <ng-content></ng-content>
</div>
